import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Modelos de e-mail transacional (T-90, admin). O backend existia desde 07/08 sem tela.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/modelos-email'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'fandata_email_templates',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
